// src/plugins/customMessage.js
import Vue from 'vue';
import CustomMessageModal from '../view/message/CustomMessageModal.vue';

let messageInstance;

const getMessageInstance = () => {
    if (!messageInstance) {
        const MessageComponent = Vue.extend(CustomMessageModal);
        messageInstance = new MessageComponent();

        // 创建挂载点
        const mountNode = document.createElement('div');
        document.body.appendChild(mountNode);

        // 挂载组件
        messageInstance.$mount(mountNode);
    }
    return messageInstance;
};

const $customMessage = {
    success(content, duration) {
        return getMessageInstance().success(content, duration);
    },
    warning(content, duration) {
        return getMessageInstance().warning(content, duration);
    },
    error(content, duration) {
        return getMessageInstance().error(content, duration);
    },
    info(content, duration) {
        return getMessageInstance().info(content, duration);
    }
};

export default {
    install(Vue) {
        Vue.prototype.$customMessage = $customMessage;
    }
};

export { $customMessage };
